/**
 * Use this function whenever you expect the code in a given place (line) to NEVER be invoked.
 * This function throws a runtime error if it is ever called, indicating that the code flow
 * has reached an unreachable point.
 *
 * @param value - The value that should never be reached.
 *
 * @throws {Error} - Throws an error indicating that an unreachable point has been reached.
 *
 * @example - usage:
 *   enum Direction { Up, Down }
 *
 *   const move = (direction: Direction): void => {
 *     switch (direction) {
 *       case Direction.Up: {
 *         moveUp();
 *         break;
 *       }
 *       case Direction.Down: {
 *         moveDown();
 *         break;
 *       }
 *       default: {
 *         assertUnreachable(direction);
 *       }
 *     }
 *   }
 */
export const assertUnreachable = (value: never): never => {
  throw new Error(`Unreachable point has been reached with the '${value}' value!`);
};
